<template>
  <div class="w-full">
    <textarea
      v-model="processedString"
      rows="4"
      class="template-input"
      @input="handleTextChange"
    />
    <div v-if="variables" class="template__variables-container">
      <p class="variables-label">
        {{ $t("WHATSAPP_TEMPLATES.PARSER.VARIABLES_LABEL") }}
      </p>
      <div
        v-for="(variable, key) in processedParams"
        :key="key"
        class="template__variable-item"
      >
        <span class="variable-label">
          {{ key }}
        </span>
        <woot-input
          v-model="processedParams[key]"
          type="text"
          class="variable-input"
          :styles="{ marginBottom: 0 }"
        />
      </div>
      <p v-if="$v.$dirty && $v.$invalid" class="error">
        {{ $t("WHATSAPP_TEMPLATES.PARSER.FORM_ERROR_MESSAGE") }}
      </p>
    </div>
    <footer>
      <woot-button :variant="smooth" @click="$emit('resetTemplate')">
        {{ $t("WHATSAPP_TEMPLATES.PARSER.GO_BACK_LABEL") }}
      </woot-button>
      <woot-button
        class="min-w-[150px] flex items-center justify-center text-center"
        :isDisabled="isLoading"
        type="button"
        :variant="smooth"
        @click="sendMessage"
      >
        <div class="text-center" v-if="isLoading">Sending...</div>
        <div class="text-center" v-else>
          {{ $t("WHATSAPP_TEMPLATES.PARSER.SEND_MESSAGE_LABEL") }}
        </div>
      </woot-button>
    </footer>
  </div>
</template>

<script>
const allKeysRequired = (value) => {
  const keys = Object.keys(value);
  return keys.every((key) => value[key]);
};
import { requiredIf } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  props: {
    template: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    processedParams: {
      requiredIfKeysPresent: requiredIf("variables"),
      allKeysRequired,
    },
  },
  data() {
    return {
      processedParams: {},
      bodyMessage: "",
      updatedWhatsappPayload: null,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      currentChat: "getSelectedChat",
      currentUser: "getCurrentUser",
      globalConfig: "globalConfig/get",
      accountId: "getCurrentAccountId",
      getSelectedChat: "getSelectedChat",
      getCurrentUser: "getCurrentUser",
    }),
    variables() {
      const variables = this.templateString.match(/{{([^}]+)}}/g);
      return variables;
    },
    templateString() {
      return this.template.components.find((component) => component.type === "BODY").text;
    },
  processedString() {
    return this.bodyMessage.length
      ? this.bodyMessage
      : this.templateString.replace(/{{([^}]+)}}/g, (match, variable) => {
          const variableKey = this.processVariable(variable);
          return this.processedParams[variableKey] || `{{${variable}}}`;
        });
  },
  },
  mounted() {
    this.generateVariables();
  },
  methods: {
    handleTextChange(event) {
      this.bodyMessage = event.target.value;
    },
    async sendMessage() {
      this.isLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const accessToken = this.template.accessToken;
      const phoneNumberId = this.template.phoneNumberId;
      const whatsappPayload = { ...this.template.whatsappTemplatePayload };
      const updatedMessage = this.bodyMessage.length
        ? this.bodyMessage
        : this.processedString;
      const bodyComponent = whatsappPayload.template.components.find(
        (c) => c.type === "BODY"
      );
      if (bodyComponent) {
        bodyComponent.parameters[0].text = updatedMessage;
      }

      const apiUrl = `https://graph.facebook.com/v18.0/${phoneNumberId}/messages`;

      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(whatsappPayload),
        });
        const result = await response.json();
      } catch (err) {
        console.log("Error sending message", err);
      }

      const payload = {
        message: updatedMessage,
        templateParams: {
          name: this.template.name,
          category: this.template.category,
          language: this.template.language,
          namespace: this.template.namespace,
          processed_params: this.processedParams,
        },
      };
      this.$emit("sendMessage", payload);
      this.isLoading = false;
    },
    processVariable(str) {
      return str.replace(/{{|}}/g, "");
    },
    generateVariables() {
      const matchedVariables = this.templateString.match(/{{([^}]+)}}/g);
      if (!matchedVariables) return;

      const variables = matchedVariables.map((i) => this.processVariable(i));
      this.processedParams = variables.reduce((acc, variable) => {
        acc[variable] = "";
        return acc;
      }, {});
    },
  },
};
</script>

<style scoped lang="scss">
.template__variables-container {
  @apply p-2.5;
}

.variables-label {
  @apply text-sm font-semibold mb-2.5;
}

.template__variable-item {
  @apply items-center flex mb-2.5;

  .label {
    @apply text-xs;
  }

  .variable-input {
    @apply flex-1 text-sm ml-2.5;
  }

  .variable-label {
    @apply bg-slate-75 dark:bg-slate-700 text-slate-700 dark:text-slate-100 inline-block rounded-md text-xs py-2.5 px-6;
  }
}

footer {
  @apply flex justify-end;

  button {
    @apply ml-2.5;
  }
}
.error {
  @apply bg-red-100 dark:bg-red-100 rounded-md text-red-800 dark:text-red-800 p-2.5 text-center;
}
.template-input {
  @apply bg-slate-25 dark:bg-slate-900 text-slate-700 dark:text-slate-100;
}
</style>